function loop(theme, res, list, type) {
  const suffixes = { main: '', light: 'light', ultralight: 'ultralight', dark: 'dark', ultradark: 'ultradark' };
  const suffixe = suffixes[type];
  list.forEach(key => {
    res[`${key}${suffixe}`] = {
      backgroundColor: theme.palette[key][type],
      color: theme.palette[key].contrastText,
    };
    res[`text-${key}${suffixe}`] = {
      color: theme.palette[key][type],
    };
  });
}

export default theme => {
  const main = [
    'white',
    'black',
    'grey',
    'blue',
    'brown',
    'green',
    'khaki',
    'orange',
    'pink',
    'purple',
    'red',
    'teal',
    'yellow',
  ];
  const light = ['grey', 'red', 'green', 'blue', 'orange', 'purple', 'teal', 'yellow'];
  const ultralight = ['blue', 'green'];
  const dark = ['blue', 'green', 'khaki', 'pink', 'purple', 'red', 'teal'];
  const ultradark = ['red'];

  const res = {
    title: {
      margin: theme.spacing(8),
      textTransform: 'none',
      fontFamily: '"Prata", sans-serif',
      fontWeight: 400,
      '& .textToBeChanged': {
        color: theme.palette.red.main,
      },
      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
      },
      [theme.breakpoints.down('xs')]: {
        flexDirection: 'column',
        textAlign: 'center',
        margin: '25px',
      },
    },
    image: {
      width: '100%',
      height: '400px',
      objectFit: 'cover',
      objectPosition: 'center',
      [theme.breakpoints.down('sm')]: {
        objectFit: 'contain',
        width: '100%',
        height: 'initial',
      },
    },
    imageText: {
      height: '300px',
      objectFit: 'contain',
      objectPosition: 'center',
      boxSizing: 'content-box',
      [theme.breakpoints.down('sm')]: {
        objectFit: 'contain',
        width: '100%',
        height: 'initial',
      },
    },
    textWrapper: {
      display: 'flex',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
      },
      [theme.breakpoints.down('xs')]: {
        padding: '0',
        margin: '25px',
        width: '80%',
      },
      '& > *': {
        width: '100%',
        '&:first-child': {
          padding: theme.spacing(8, 4, 8, 8),
          [theme.breakpoints.down('sm')]: {
            paddingRight: 0,
          },
          [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
            margin: '0',
            padding: '0',
          },
        },
        '&:last-child': {
          padding: theme.spacing(8, 8, 8, 4),
          [theme.breakpoints.down('sm')]: {
            paddingLeft: theme.spacing(3),
          },
          [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
            margin: '0',
            padding: '0',
          },
        },
        '& > *': {
          paddingBottom: theme.spacing(2),
        },
      },
    },
    desc: {
      display: 'flex',
      '& > *': {
        width: '100%',
      },
      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
      },
      [theme.breakpoints.down('xs')]: {
        flexDirection: 'column',
        margin: '25px',
        padding: '0',
      },
    },
    asideBlock: {
      position: 'relative',
      display: 'block',
      padding: theme.spacing(8),
      paddingTop: theme.spacing(2),
      backgroundColor: theme.palette.orange.light,
      color: theme.palette.blue.dark,
      [theme.breakpoints.down('xs')]: {
        flexDirection: 'column',
        padding: '25px',
      },
    },
    asideTitle: {
      paddingBottom: theme.spacing(2),
    },
    asideImage: {
      width: '33%',
      objectFit: 'contain',
      maxWidth: '200px',
      [theme.breakpoints.down('xs')]: {
        marginBottom: theme.spacing(2),
      },
    },
    aside: {
      marginTop: theme.spacing(4),
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      gap: theme.spacing(8),
      [theme.breakpoints.down('xs')]: {
        margin: '0',
        flexDirection: 'column',
        alignItems: 'center',
        gap: theme.spacing(1),
      },
    },
    imgLeft: {
      [theme.breakpoints.down('xs')]: {
        flexDirection: 'column-reverse',
      },
    },
  };

  loop(theme, res, main, 'main');
  loop(theme, res, light, 'light');
  loop(theme, res, dark, 'dark');
  loop(theme, res, ultralight, 'ultralight');
  loop(theme, res, ultradark, 'ultradark');

  return res;
};
